/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobsList_paymentStatusTypes$ref: FragmentReference;
declare export opaque type JobsList_paymentStatusTypes$fragmentType: JobsList_paymentStatusTypes$ref;
export type JobsList_paymentStatusTypes = {|
  +enumValues: ?$ReadOnlyArray<{|
    +name: string,
    +description: ?string,
  |}>,
  +$refType: JobsList_paymentStatusTypes$ref,
|};
export type JobsList_paymentStatusTypes$data = JobsList_paymentStatusTypes;
export type JobsList_paymentStatusTypes$key = {
  +$data?: JobsList_paymentStatusTypes$data,
  +$fragmentRefs: JobsList_paymentStatusTypes$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "JobsList_paymentStatusTypes",
  "type": "__Type",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "enumValues",
      "storageKey": null,
      "args": null,
      "concreteType": "__EnumValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '452e20cd703946383ec6602e58e65bcf';
module.exports = node;
